<template>
<div class="boxMain">
	  <!--<img src="../../assets/images/xin/logo.png" class="logo-img" alt="" />-->
	   <p class="logo-title">山西省职业教育铸魂育人计划项目监测与管理平台</p>
	  <div id="loginBox" class="login-box border-box" @click.stop>
	    <div class="title-box">用户登录</div>
	    <div class="from-box">
	      <div
	        class="item-box flex align-items-center"
	        :class="true ? 'border' : 'border-active'"
	      >
	        <img class="img-box" src="../../assets/images/xin/user.png" alt="" />
	        <input
	          class="flex-1 input-style"
	          type="text"
	          v-model="loginData.username"
	          placeholder="请输入账号"
	          :disabled="loading"
	          @keyup.enter="handleLogin"
	        />
	      </div>
	      <div
	        class="item-box flex align-items-center"
	        :class="true ? 'border' : 'border-active'"
	      >
	        <img class="img-box" src="../../assets/images/xin/password.png" alt="" />
	        <input
	          class="flex-1 input-style"
	          type="password"
	          v-model="loginData.password"
	          placeholder="请输入密码"
	          :disabled="loading"
	          @keyup.enter="handleLogin"
	        />
	      </div>
	      <div
	        class="item-box flex align-items-center item-boxs"
	        :class="true ? 'border' : 'border-active'"
	      >
	        <!--<img class="img-box" src="../../assets/images/img8.png" alt="" />-->
	        <input
	          class="input-style input-style1"
	          type="text"
	          v-model="loginData.captcha"
	          placeholder="请输入验证码"
	          :disabled="loading"
	          @keyup.enter="handleLogin"
	        />
	        <img
	          class="img-box-1"
	          :class="{ disabled: loading }"
	          :src="verificationImg"
	          alt=""
	          @click="!loading && getCaptcha()"
	        />
	      </div>
	      <div
	        class="item-boxbtn"
	        :class="{ 'is-loading': loading }"
	        @click="handleLogin"
	      >
	        <span v-if="loading" class="login-spinner"></span>
	        <span>{{ loading ? '登录中...' : '登　　录' }}</span>
	      </div>
	    </div>
	  </div>
 </div>
</template>

<script>
import { goLogin, getCaptcha } from "../../api/index.js";
export default {
  name: "",
  components: {},
  props: {
    loginPath: String,
  },
  data() {
    return {
      loading: false,
      verificationImg: "",
      loginData: {
        username: "",
        password: "",
        captcha: "",
        checkKey: "",
      },
      name:'szStudio',
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
//	if(this.$route.query.name){
//		this.name=this.$route.query.name;
//	}

    this.getCaptcha();
    window.addEventListener('keydown', this.keyDown, false);
  },
  methods: {
    handleLogin() {
      if (this.loading) {
        return false;
      }
      if (this.loginData.username === "") {
        this.$message.info("请输入账号");
        return false;
      } else if (this.loginData.password === "") {
        this.$message.info("请输入密码");
        return false;
      } else if (this.loginData.captcha === "") {
        this.$message.info("请输入验证码");
        return false;
      }
      this.loading = true;
      goLogin(this.loginData)
        .then((res) => {
          if (res && res.code === 200) {
            this.$store.state.token = res.result.token;
            window.sessionStorage.setItem("token", res.result.token);
            window.sessionStorage.setItem(
              "userInfo",
              JSON.stringify(res.result.userInfo)
            );
            window.sessionStorage.setItem("userRole", res.result.userRole[0]);
            window.sessionStorage.setItem("departs", JSON.stringify(res.result.departs));
            this.$store.commit("updateUser", res.result.userInfo);
            this.$store.commit("updateToken", res.result.token);
            this.$store.commit("updateRole", res.result.userRole[0]);
            this.$message.success(res.message);
            window.removeEventListener('keydown', this.keyDown, false);
            this.$router.push({ name: 'Homes' });
          } else {
            this.loading = false;
            this.getCaptcha();
            this.$message.error((res && res.message) || "登录失败，请稍后重试");
          }
        })
        .catch(() => {
          this.loading = false;
          this.getCaptcha();
          this.$message.error("登录失败，请稍后重试");
        });
    },
    keyDown(e) {
      if (e.keyCode === 13 || e.key === 'Enter') {
        e.preventDefault();
        this.handleLogin();
        return false;
      }
    },
    getCaptcha() {
      this.loginData.checkKey = new Date().getTime();
      getCaptcha(this.loginData.checkKey).then((res) => {
        this.verificationImg = res.result;
      });
    },
  },
  destroyed(){
    window.removeEventListener('keydown', this.keyDown, false);
  }
};

</script>

<style scoped lang="scss">
.boxMain{
   height: 100vh;
  background: url("../../assets/images/xin/bg2.png") no-repeat; 
  background-repeat: no-repeat;
  overflow: auto;
  background-size: 100% 100%;
}
.logo-img{
	width:135px;
	height:135px;
	display: block;
	margin:6vh auto 0px;
}
.logo-title{
font-weight: bold;
font-size: 40px;
color: #FFFFFF;
line-height: 60px;
background: linear-gradient(0deg, #FFFFFF 0%, #00F6FF 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
text-align: center;
margin-top:10vh;
margin-bottom:40px;
}
.img-box {
  width: 19px;
  height: 19px;
  margin-right: 16px;
 }

.img-box-1 {
  width: 100px;
  height: auto;
  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
}
.login-box {
  width: 990px;
  height: 520px;
  padding: 10px 86px;
  /*margin-bottom: 14%;*/
  background: url("../../assets/images/xin/center.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin:0px auto;
  cursor:pointer;
}
.title-box {
  height: 60px;
  margin-top: 20px;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  font-size: 30px;
  color: #FFFFFF;
}
.from-box{
	width:482px;
	margin:0px auto;
}
.input-style {
  border: none;
  color: #fff;
  margin:10px 0px;
  line-height: 27px;
  height:27px;
  padding:0px 0px 0px 14px;
  background: transparent;
  border-left:1px solid #439EEB;
}
.input-style1{
	 border: 1px solid #0967AF;
	 background: #054283;
	 padding:0px 16px;
	 box-sizing: border-box;
	 width:70%;
	 height: 100%;
	 line-height: 47px;
	 margin:0px;
	 border-radius: 4px;
}
input::placeholder{
  color: #fff;
}
.item-box {
  padding: 0 20px;
  height: 47px;
  line-height: 47px;
  border-radius: 4px;
  background-color: #054283;
}
.item-boxbtn{
  padding: 0 20px;
  height: 57px;
  line-height: 57px;
  background: rgba(19,92,217,0.64);
  border-radius: 5px;
  border: 1px solid #42ADFF;
  text-align: center;
  margin-top:60px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: opacity 0.2s ease, background 0.2s ease;
  &.is-loading {
    opacity: 0.85;
    cursor: not-allowed;
    pointer-events: none;
    background: rgba(19,92,217,0.9);
  }
  .login-spinner {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: #ffffff;
    border-radius: 50%;
    box-sizing: border-box;
    animation: login-spin 0.75s linear infinite;
    flex-shrink: 0;
  }
}
@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}
.border {
  border: 1px solid #0967AF;
}
.border-active {
  border: 1px solid #eecfc9;
}
.item-boxs{
	padding: 0px;
    background-color: transparent;
    border:none;
    justify-content: space-between;
}
.item-box:nth-child(1) {
  margin-top: 27px;
}
.item-box:nth-child(2) {
  margin-top: 23px;
}
.item-box:nth-child(3) {
  margin-top: 23px;
}
.item-box:nth-child(4) {
  margin-top: 30px;
  text-align: center;
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>
